import {ProductSale} from './ProductSale';
import {ProductName} from './ProductName';
import {ProductPrice} from './ProductPrice';
import {ProductRating} from './ProductRating';
import {ProductInCart} from './ProductInCart';
import {ProductCounter} from './ProductCounter';
import {ProductInWishlist} from './ProductInWishlist';
import {ProductCounterInner} from './ProductCounterInner';
import {ProductSales} from './ProductSalestype';

export const product = {
  ProductSale,
  ProductName,
  ProductPrice,
  ProductInCart,
  ProductRating,
  ProductCounter,
  ProductInWishlist,
  ProductCounterInner,
  ProductSales,
};
